
import HttpClienteToken from '../../services/HttpClientToken';

import { AxiosError } from 'axios';

import { HttpResponse } from '../../interfaces/auth/AuthInterface';

import { ParteProps } from '../../interfaces/comun/ParteInterface';
import { AgregarAnexosAmparoParams, AgregarPartesAmparoParams, AmparoProps, BuscarAmparoParams, GenerarAmparoParams, GenerarAmparoResponse } from '../../interfaces/comun/AmparoInterface';

export const AgregarPartesAmparo = ( params: AgregarPartesAmparoParams ) => {

    return new Promise<HttpResponse>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Amparo/AgregarPartes', params, token)
            .then( ({ data } : { data : HttpResponse } ) => {  
                resolve( data );                
            })
            .catch( ( error: AxiosError ) => {
                resolve({
                    success: false,
                    message: error.message,
                });
            });
        }

    });

}

export const AgregarAnexosAmparo = ( params: AgregarAnexosAmparoParams ) => {

    return new Promise<HttpResponse>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Amparo/AgregarAnexos', params, token)
            .then( ({ data } : { data : HttpResponse } ) => {  
                resolve( data );                
            })
            .catch( ( error: AxiosError ) => {
                resolve({
                    success: false,
                    message: error.message,
                });
            });
        }

    });

}

export const GenerarAmparo = ( params: GenerarAmparoParams ) => {

    return new Promise<GenerarAmparoResponse>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Amparo/GenerarAmparo', params, token)
            .then( ({ data } : { data : GenerarAmparoResponse } ) => {  
                resolve( data );                
            })
            .catch( ( error: AxiosError ) => {
                resolve({
                    success: false,
                    message: error.message,
                });
            });
        }

    });

}

export const ObtenerPartesAmparo = ( id: string ) => {

    return new Promise<ParteProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get(`/Api/Amparo/ObtenerPartes/${ id }`, token)
            .then( ({ data } : { data : ParteProps[] } ) => {  
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const BuscarAmparo = ( params: BuscarAmparoParams ) => {

    return new Promise<AmparoProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Amparo/BuscarAmparo', params, token)
            .then( ({ data } : { data : AmparoProps[] } ) => {  
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}